import { useNavigate } from "@tanstack/react-router";
import { darken, lighten } from "@mui/material/styles";
import { grey } from "@mui/material/colors";
import Chip from "@mui/material/Chip";
import { DataTable } from "../../components/DataTable";

const getBackgroundColor = (color, mode) =>
  mode === "dark" ? darken(color, 0.7) : lighten(color, 0.7);

const getHoverBackgroundColor = (color, mode) =>
  mode === "dark" ? darken(color, 0.6) : lighten(color, 0.6);

const blockedRowStyles = (theme) => ({
  "& .Blocked-Yes": {
    backgroundColor: getBackgroundColor(grey[300], "light"),
    "&:hover": {
      backgroundColor: `${getHoverBackgroundColor(grey[300], "light")} !important`,
    },
    ...theme.applyStyles("dark", {
      backgroundColor: getBackgroundColor(grey[300], "dark"),
      "&:hover": {
        backgroundColor: `${getHoverBackgroundColor(grey[300], "dark")} !important`,
      },
    }),
  },
});

const columns = [
  {
    accessorKey: "contractCode",
    header: "Contract Code",
    meta: { minWidth: 150 },
  },
  {
    accessorKey: "description",
    header: "Description",
    meta: { minWidth: 400 },
  },
  {
    accessorKey: "blocked",
    header: "Status",
    meta: { minWidth: 150 },
    cell: (info) => (
      <Chip
        variant="outlined"
        color={info.getValue() === "Yes" ? "error" : "success"}
        clickable={false}
        label={info.getValue() === "Yes" ? "Blocked" : "Active"}
      />
    ),
  },
];

export const ContractTable = ({
  contracts,
  loading,
  contractFilter,
  setContractFilter,
}) => {
  const navigate = useNavigate();
  const contractList = contracts?.contract || [];
  const rowCount = Number(contracts?.paging?.noOfRecords) || 0;

  const pagination = {
    page: (contractFilter?.page ?? 1) - 1,
    pageSize: contractFilter?.pageSize ?? 25,
  };

  const handlePaginationChange = (next) => {
    setContractFilter((prevState) => ({
      ...prevState,
      page: next.page + 1,
      pageSize: next.pageSize,
    }));
  };

  return (
    <DataTable
      aria-label="Contracts"
      columns={columns}
      rows={contractList}
      getRowId={(row) => row.no}
      rowCount={rowCount}
      page={pagination.page}
      pageSize={pagination.pageSize}
      loading={loading}
      onPaginationChange={handlePaginationChange}
      onRowClick={(row) => navigate({ to: `/contracts/${row.no}` })}
      getRowClassName={(row) => `Blocked-${row.blocked}`}
      sx={blockedRowStyles}
    />
  );
};
